import { render, staticRenderFns } from "./HomeAssetPage.vue?vue&type=template&id=e064340c"
import script from "./HomeAssetPage.vue?vue&type=script&lang=js"
export * from "./HomeAssetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports